import { UPDATE_SEARCH_PROGRESS_BREAKDOWN } from "actions/constants";

const initialState = {
  progressBreakdown: {},
  selectedTimelineCycle: null,
};

const searchProgressBreakdown = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_PROGRESS_BREAKDOWN: {
      const { progressBreakdown, selectedTimelineCycle } = action.payload;

      return {
        ...state,
        progressBreakdown: progressBreakdown || {},
        selectedTimelineCycle:
          selectedTimelineCycle || state.selectedTimelineCycle,
      };
    }

    default:
      return state;
  }
};

export default searchProgressBreakdown;
